<template>
  <h1>Not Found!</h1>
</template>

<script>
import router from '@/router';

export default {
  name: 'NotFoundPage',
  mounted() {
     return router.push('/');
  }
}
</script>